import {Component} from '@angular/core';
import {Router, ActivatedRoute,NavigationEnd} from '@angular/router';

import {BreadcrumbComponent, BreadcrumbService} from 'ng5-breadcrumb';

@Component({
    selector: 'custom-breadcrumb',
    template: `
    <div class="ui-breadcrumb ui-widget ui-widget-header ui-helper-clearfix ui-corner-all">
        <ul>
            <li *ngFor="let url of _urls; let last = last; let first = first" [ngClass]="{'chevron': !first}">
                <a class="ui-menuitem-link" role="button" *ngIf="first" (click)="navigateTo('/')">
                    <span class="ui-menuitem-text">{{menu}}</span>
                </a>
                <a class="ui-menuitem-link" role="button" *ngIf="(!last && !first) || (!consultaRegex(url) && last)" (click)="navigateTo(url)">
                    <span class="ui-menuitem-text">{{friendlyName(bread)}}</span>
                </a>
                <span *ngIf="consultaRegex(url)"> {{friendlyName(url)}}</span>
                <span *ngIf="last && url == prefix">{{friendlyName('/')}}</span>
            </li>
        </ul>
    </div>
    `
})
export class CustomBreadcrumbComponent extends BreadcrumbComponent {
    bread:any;
    menu:any;
    constructor(activeRoute: ActivatedRoute, router: Router, breadcrumbService: BreadcrumbService){
        super(router, breadcrumbService);
        router.events.filter(event => event instanceof NavigationEnd).subscribe((routeChange) => {
           this.bread =  this.getBread(activeRoute);
           this.menu =  this.getMenu(activeRoute);
          });

    }

    consultaRegex(test){
        const regex = /([a-z]*)\/visualizar\/([0-9]*)/;
        const regex2 = /([a-z]*)\/editar\/([0-9]*)/;
        const regex3 = /([a-z]*)\/cadastrar/;
        const regex4 = /([a-z]*)\/historico\/([0-9]*)/;
        const regex5 = /([a-z]*)\/relatorio\/([0-9]*)/;
        if(regex.test(test)){
            return true;
        }
        else if(regex2.test(test)){
            return true;
        }
        else if(regex3.test(test)){
            return true;
        }
        else if(regex4.test(test)){
            return true;
        }
        else if(regex5.test(test)){
            return true;
        }
        else{
            return false;
        }
        
    }

    getBread(route:ActivatedRoute){
        let children: ActivatedRoute[] = route.children;

        for (let child of children) {
            if(!child.snapshot.data.hasOwnProperty('Breadcrumb')){
                return this.getBread(child);
            }
           return child.snapshot.data['Breadcrumb'];
        }

    }

    getMenu(route:ActivatedRoute){
        let children: ActivatedRoute[] = route.children;

        for (let child of children) {
            if(!child.snapshot.data.hasOwnProperty('Menu')){
                return this.getMenu(child);
            }
           return child.snapshot.data['Menu'];
        }

    }
}


// WEBPACK FOOTER //
// ./src/app/util/custom-breadcrumb.component.ts